export default {
  type: 'object',
  properties: {
    uid: {
      title: 'UID dokumentu z MDOK',
      type: 'number',
      fieldRequired: true
    }
  }
};
